import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'

// icon rules: we get all the icon properties from templateId first characters
// - shape index is based on templateId first character
// - color index is based on the second
// - rotation is based on the third

export default class Icon extends PureComponent {
  static propTypes = {
    templateId: PropTypes.string.isRequired,
    size: PropTypes.number.isRequired,
    className: PropTypes.any,
  }

  static defaultProps = {
    size: 16,
  }

  render() {
    const shapeIndex = this.props.templateId.charCodeAt(0) % SHAPES.length
    const colorIndex = this.props.templateId.charCodeAt(1) % COLORS.length
    const rotation = (this.props.templateId.charCodeAt(2) % 4) * 90

    return (
      <svg
        style={{ transform: `rotate(${rotation}deg)`, fill: 'currentColor' }}
        className={classNames(this.props.className, COLORS[colorIndex])}
        width={this.props.size}
        height={this.props.size}
      >
        {SHAPES[shapeIndex]}
      </svg>
    )
  }
}

const SHAPES = [
  <g>
    <path d="M0 0V16H16L0 0Z" />
    <path
      opacity="0.4"
      d="M16 16L3.48409e-05 3.76384e-05L16 3.62396e-05L16 16Z"
    />
  </g>,
  <g>
    <path
      opacity="0.4"
      d="M3.45866e-05 3.59853e-05L3.52859e-05 16L16 16L16 15.3846C16 6.89233 9.10771 3.55872e-05 0.615418 3.59584e-05L3.45866e-05 3.59853e-05Z"
    />
    <path d="M3.39686e-05 8.31998L0.320034 8.31998C4.54402 8.31998 8.00002 11.776 8.00002 16L16 16C16 7.16798 8.83202 -3.13323e-07 3.43323e-05 -6.99381e-07L3.39686e-05 8.31998Z" />
  </g>,
  <g>
    <path d="M2.33781 2.34876L13.6507 13.6619C12.2033 15.1066 10.2056 16 7.99965 16C3.58232 16 -0.00024449 12.4174 -0.00024449 7.99993C-0.00024449 5.79396 0.893173 3.79617 2.33781 2.34876Z" />
    <path
      opacity="0.4"
      d="M13.6558 13.6668C16.7827 10.5399 16.7827 5.4721 13.6558 2.34519C10.529 -0.781729 5.46134 -0.781728 2.33449 2.34519L13.6558 13.6668Z"
    />
  </g>,
  <g>
    <path
      opacity="0.4"
      d="M8 16C12.4174 16 16 12.4174 16 8C16 3.58261 12.4174 0 8 0C3.58261 0 0 3.58261 0 8C0 12.4174 3.58261 16 8 16ZM8 11.1304C6.26087 11.1304 4.86957 9.73913 4.86957 8C4.86957 6.26087 6.26087 4.86957 8 4.86957C9.73913 4.86957 11.1304 6.26087 11.1304 8C11.1304 9.73913 9.73913 11.1304 8 11.1304Z"
    />
    <path d="M15.9997 8.00002H7.99976V16H8.30745C12.5536 16 15.9997 12.5539 15.9997 8.30771V8.00002Z" />
  </g>,
]

const COLORS = ['red', 'teal', 'purple', 'yellow']
